/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EmailQuoteRequestState } from "./EmailQuoteRequestState";
import {
  EmailQuoteRequestStateFromJSON,
  EmailQuoteRequestStateFromJSONTyped,
  EmailQuoteRequestStateToJSON,
  EmailQuoteRequestStateToJSONTyped,
} from "./EmailQuoteRequestState";

/**
 *
 * @export
 * @interface EmailQuoteRequestInfo
 */
export interface EmailQuoteRequestInfo {
  /**
   *
   * @type {string}
   * @memberof EmailQuoteRequestInfo
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {EmailQuoteRequestState}
   * @memberof EmailQuoteRequestInfo
   */
  state?: EmailQuoteRequestState | null;
}

/**
 * Check if a given object implements the EmailQuoteRequestInfo interface.
 */
export function instanceOfEmailQuoteRequestInfo(
  value: object,
): value is EmailQuoteRequestInfo {
  return true;
}

export function EmailQuoteRequestInfoFromJSON(
  json: any,
): EmailQuoteRequestInfo {
  return EmailQuoteRequestInfoFromJSONTyped(json, false);
}

export function EmailQuoteRequestInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailQuoteRequestInfo {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    state:
      json["state"] == null
        ? undefined
        : EmailQuoteRequestStateFromJSON(json["state"]),
  };
}

export function EmailQuoteRequestInfoToJSON(json: any): EmailQuoteRequestInfo {
  return EmailQuoteRequestInfoToJSONTyped(json, false);
}

export function EmailQuoteRequestInfoToJSONTyped(
  value?: EmailQuoteRequestInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    state: EmailQuoteRequestStateToJSON(value["state"]),
  };
}
